import { Box } from "@mui/material";
import React from "react";
import SidebarHome from "components/Layouts/components/SidebarHome";
import useMode from "hooks/useMode";

interface HomeLayout {
  children: React.ReactNode;
}

const HomeLayout: React.FC<HomeLayout> = ({ children }) => {
  const mode = useMode();
  return (
    <Box sx={{ display: "flex", height: "100vh", bgcolor: mode.secondary }}>
      {/* <SidebarHome /> */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>{children}</Box>
    </Box>
  );
};

export default HomeLayout;
